module.exports = __webpack_public_path__ + "static/img/i40.30ced78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/i40.png
// module id = tJyi
// module chunks = 3